import { css, styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

const cardBase = css`
  background: ${Colors.Semantic.Neutral.white};
  border: 1px solid ${Colors.Semantic.Neutral.medium_grey};
  border-radius: 0.5rem;
  max-width: calc(100vw - 2rem);
  position: relative;
  width: 100%;
`

export const BiddingCard = styled.div`
  ${cardBase}
  padding-top: 1.5rem;
  transition: padding 500ms ease-in-out;
`
